import { ExpandDown12 } from '@yunex/yds-icons';
import React from 'react';
export var MuiAccordionSummary = {
    defaultProps: { expandIcon: React.createElement(ExpandDown12, null) },
    styleOverrides: {
        expandIconWrapper: {
            alignItems: 'center',
        },
    },
};
